'use strict';

module.exports = function(a){
  return (!a && a !== 0) ? '' : a.toString();
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/gl-scatter3d/lib/get-simple-string.js
// module id = EJ31
// module chunks = 0